// Returns the weekday label ('SUN'..'SAT') for a YYYYMMDD value (int or string).
// Built with numeric Date components (not an ISO string) so construction and
// .getDay() both stay in the same local wall-clock — the result is identical
// in every browser timezone.
const WEEKDAY_LABELS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']

export function getWeekdayLabelFromYYYYMMDD(yyyymmdd) {
    const s = String(yyyymmdd)
    return WEEKDAY_LABELS[new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8)).getDay()]
}

export const WEEKDAYS = WEEKDAY_LABELS
